import React, { useEffect, useState } from "react";
import UnapprovedIdentifications from "../Components/UnapprovedIdentifications";
import Contacts from "../Components/Contacts";
import FAQManagement from "../Components/FAQManagement";
import UserList from "../Components/UserList";
import "./Admin.css";
import Species from "./Species";
import ModelManagement from "./ModelManagement";
import SpeciesAdmin from "../Components/SpeciesAdmin";
import UserFeedback from "../Components/UserFeedback";

function Admin({ faqData, setFaqData }) {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [activeTab, setActiveTab] = useState("unapproved");
  const [user] = useState(localStorage.getItem("user") || "");
  const [isAdmin, setIsAdmin] = useState(false);
  const [accessDenied, setAccessDenied] = useState(false);
  const [treeId] = useState(localStorage.getItem("tree") || "1");
  useEffect(() => {
    localStorage.setItem("tree", treeId);
  }, [treeId]);
  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_URL}/getProfile`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({ email: user }),
          }
        );
        const data = await response.json();
        if (data.type === "admin") {
          setIsAdmin(true);
          setIsLoggedIn(true);
        } else {
          setAccessDenied(true);
        }
      } catch (error) {
        console.error("Error fetching profile:", error);
        setAccessDenied(true);
      }
    };

    if (user) {
      fetchProfile();
    }
  }, [user]);

  const handleLogout = () => {
    setIsLoggedIn(false);
    setIsAdmin(false);
    localStorage.removeItem("user");
    window.location.href = "/";
  };

  const renderTabContent = () => {
    switch (activeTab) {
      case "unapproved":
        return <UnapprovedIdentifications />;
      case "contacts":
        return <Contacts />;
      case "faq":
        return <FAQManagement faqData={faqData} setFaqData={setFaqData} />;
      case "userlist":
        return <UserList />;
      case "species":
        return <SpeciesAdmin />;
      case "model":
        return <ModelManagement />;
      case "feedback":
        return <UserFeedback />;
      default:
        return null;
    }
  };

  return (
    <div className="admin">
      {accessDenied ? (
        <div>Access Denied...</div>
      ) : isLoggedIn && isAdmin ? (
        <div className="acitive-admin">
          <div className="tabs">
            <div className="title-container">
              <a href="/">
                <img
                  className="bnv-logo"
                  src={"/Assets/logo/Sundari.png"}
                  alt="Sundori" // Sundori logo
                />
              </a>
              <a href="/" className={`bnv-title`}>
                Sundori
              </a>
            </div>
            <button
              className={`tab ${activeTab === "unapproved" ? "active" : ""}`}
              onClick={() => setActiveTab("unapproved")}
            >
              Unapproved Identifications
            </button>
            <button
              className={`tab ${activeTab === "contacts" ? "active" : ""}`}
              onClick={() => setActiveTab("contacts")}
            >
              User Messages
            </button>
            <button
              className={`tab ${activeTab === "faq" ? "active" : ""}`}
              onClick={() => setActiveTab("faq")}
            >
              FAQ Management
            </button>
            <button
              className={`tab ${activeTab === "userlist" ? "active" : ""}`}
              onClick={() => setActiveTab("userlist")}
            >
              Users
            </button>
            <button
              className={`tab ${activeTab === "species" ? "active" : ""}`}
              onClick={() => setActiveTab("species")}
            >
              Species List
            </button>
            <button
              className={`tab ${activeTab === "model" ? "active" : ""}`}
              onClick={() => setActiveTab("model")}
            >
              CNN Management
            </button>
            <button
              className={`tab ${activeTab === "feedback" ? "active" : ""}`}
              onClick={() => setActiveTab("feedback")}
            >
              User Feedbacks
            </button>
            <button onClick={handleLogout} className="logout-button">
              Logout
            </button>
          </div>
          <div className="tab-content">{renderTabContent()}</div>
        </div>
      ) : (
        <div style={{ margin: "100px" }}>
          You can't access the admin panel...
          <br />
          <a href="/">Go Home..</a>
        </div>
      )}
    </div>
  );
}

export default Admin;
